import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import menu from "./menu/reducer";
import { siteReducer as site } from './site/reducer';
import userInfo from "./user-info/reducer";

export default (history) =>
    combineReducers({
        userInfo,
        menu,
        router: connectRouter(history),
        site
    });
